import CartContainer from './containers/CartContainer';

export default CartContainer;
